import type { ReactNode } from 'react';
import { createContext, useContext } from 'react';

import { Vertical } from '#src/atoms/layout/flex/index.tsx';

const PaymentMethodHintContext = createContext<ReactNode>(null);

type ProviderProps = {
  hint: ReactNode;
  children: ReactNode;
};

export const PaymentMethodHintProvider = ({
  hint,
  children,
}: ProviderProps) => (
  <PaymentMethodHintContext.Provider value={hint}>
    {children}
  </PaymentMethodHintContext.Provider>
);

const PaymentMethodHint = () => {
  const hint = useContext(PaymentMethodHintContext);

  return hint ? <>{hint}</> : null;
};

export const PaymentMethodLabelWithHint = ({
  children,
}: {
  children: ReactNode;
}) => (
  <Vertical gap={0} className="text-left">
    {children}
    <PaymentMethodHint />
  </Vertical>
);
